import { Grid2 as Grid } from "@mui/material";
import { TypesFilter } from "./typesFilter";

export const Filters = () => {
	return (
		<Grid
			container
			size={{ xs: 12, md: 10 }}
			spacing={2}
			justifyContent="flex-start"
			alignItems="center"
			style={{ padding: "8px 8px 8px 0" }}
		>
			<Grid size={{ xs: 6, md: 2 }}>
				<TypesFilter />
			</Grid>
		</Grid>
	);
};
